import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
/* datas */
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
/* document */
import { Navigation } from '../../Components/Admin/Document/Navigation.js';
import { Header } from '../../Components/Admin/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';
import { FormUpdate } from '../../Components/Admin/Form/FormUpdate.js';
import { AutoComplete } from '../../Components/Admin/Functions/AutoComplete.js';

export const Update = () => {
    const { entity, id } = useParams();
    const backend = HostBackend();
    const token = sessionStorage.getItem('token');
    const [datas, setDatas] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasUpdate = await fetch(`${backend}/admin/form/${entity}?id=${id}`, GetHeaders(token));
            const datas = await datasUpdate.json();
            setDatas(datas);
        };
        fetchData();
    }, [backend, entity, id, token]);
    if (token) {
        return (
            <div className="update">
                <Navigation entity={entity} />
                <Header />
                <FormUpdate entity={entity} datas={datas} id={id} />
                <BackTop />
                <Footer />
                <script>{AutoComplete()}</script>
            </div>
        )
    } else {
        return (<></>)
    }
}